import angular from 'angular';
import uiModal from 'angular-ui-bootstrap/src/modal';
import { DashboardComponent } from './dashboard.component.js';
import animateFaze from './animateFaze.directive.js';

const dashboard = angular.module('dashboard', [uiModal]);

dashboard.component('dashboard', DashboardComponent);
dashboard.directive('animateFaze', animateFaze);

export { dashboard };



// WEBPACK FOOTER //
// ./app/components/dashboard/dashboard.js